import { AbstractSlingoAnimationSpineProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractSlingoAnimationProperties";
/**
 * SlingoAnimationPortraitProperties.ts
 */
export class SlingoAnimationPortraitProperties extends AbstractSlingoAnimationSpineProperties {
    constructor() {
        super();
        this.position.set(512, 900);
        this.animationNameArray = ["", "slingo-win-single", "slingo-win-double", "slingo-win-triple", "slingo-win-quadruple"];
    }
}
//# sourceMappingURL=SlingoAnimationPortraitProperties.js.map